/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Swap_SecondsInputs */

const en_us2_swap_seconds = /** @type {(inputs: Swap_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const pt_br2_swap_seconds = /** @type {(inputs: Swap_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const es_419_swap_seconds = /** @type {(inputs: Swap_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const pt_pt2_swap_seconds = /** @type {(inputs: Swap_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const fr_fr2_swap_seconds = /** @type {(inputs: Swap_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const de_de2_swap_seconds = /** @type {(inputs: Swap_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

const it_it2_swap_seconds = /** @type {(inputs: Swap_SecondsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.seconds} s`)
};

/**
* | output |
* | --- |
* | "{seconds} s" |
*
* @param {Swap_SecondsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const swap_seconds = /** @type {((inputs: Swap_SecondsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Swap_SecondsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_swap_seconds(inputs)
	if (locale === "es-419") return es_419_swap_seconds(inputs)
	if (locale === "pt-PT") return pt_pt2_swap_seconds(inputs)
	if (locale === "fr-FR") return fr_fr2_swap_seconds(inputs)
	if (locale === "de-DE") return de_de2_swap_seconds(inputs)
	if (locale === "it-IT") return it_it2_swap_seconds(inputs)
	return en_us2_swap_seconds(inputs)
});
export { swap_seconds as "swap.seconds" }